/* eslint-disable */
const MealEntity = Backbone.Model.extend({
	defaults: {
		id: null,
		name: null,
		code: null
	}
});

export default MealEntity;